

export const LandingBenefits = () => {
  return null;
};